import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'StripeConfirmation',
  data () {
    return {
      attempts: 0,
      maxAttempts: 20,
      error: false,
      success: false
    }
  },
  computed: {
    ...mapGetters([
      'workspaces',
      'contentplans'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    }
  },
  methods: {
    ...mapActions([
      'loadWorkspaces',
      'contentplanGetList'
    ]),
    async redirectToWorkspace (workspace) {
      this.success = true

      // Wait 2 seconds before redirecting
      await new Promise(resolve => setTimeout(resolve, 2000))

      if (workspace.type === 'managed') {
        await this.contentplanGetList({ workspaceId: this.workspaceId })
        this.$router.push({
          name: 'ContentplanSettings',
          params: {
            workspaceId: this.workspaceId,
            contentplanId: this.contentplans[0].id
          },
          query: {
            tab: 'subscription'
          }
        })
      } else {
        this.$router.push({
          name: 'PaidClusterer',
          params: {
            workspaceId: this.workspaceId
          }
        })
      }
    },
    async loadData () {
      await this.loadWorkspaces()
      this.intervalId = setInterval(async () => {
        await this.loadWorkspaces()
        const workspace = this.workspaces.find(workspace => workspace.id === this.workspaceId)
        if (workspace && workspace.subscription_active) {
          clearInterval(this.intervalId)
          await this.redirectToWorkspace(workspace)
        } else if (this.attempts >= this.maxAttempts) {
          clearInterval(this.intervalId)
          this.error = true
        }
        this.attempts++
      }, 5000)
    }
  },
  async mounted () {
    await this.loadData()
  },
  beforeDestroy () {
    // Clean up interval when component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }
}
